import * as Yup from 'yup';

import { AddressSchema } from './address';
import { OrderSettingsSchema } from './order-settings';

export const VendorOrderingSchema = Yup.object().shape({
  send_methods: Yup.array().of(Yup.string().required()).required(),
  default_send_method: Yup.string().required(),
  download_file_format: Yup.string().defined(),
});

export const VendorReceivingSchema = Yup.object().shape({
  invoice_formats: Yup.array().of(Yup.string().required()).required(),
});

export const VendorPricingSchema = Yup.object().shape({
  sources: Yup.array().of(Yup.string().required()).required(),
  has_volume_pricing: Yup.boolean().required(),
});

export const VendorIntegrationSchema = Yup.object().shape({
  normalized_name: Yup.string().required(),
  label: Yup.string().required(),
  state: Yup.string().required(),
  ordering: VendorOrderingSchema.required(),
  receiving: VendorReceivingSchema.optional().nullable().default(null),
  pricing: VendorPricingSchema.optional().nullable().default(null),
});

export type VendorIntegration = Yup.InferType<typeof VendorIntegrationSchema>;

// form validation rules
export const VendorSchema = Yup.object().shape({
  vendor_id: Yup.string().required(),
  store_id: Yup.string().required(),
  name: Yup.string().required(),
  normalized_name: Yup.string().defined(),
  account_number: Yup.string().defined(),
  terms: Yup.string().defined(),
  notes: Yup.string().defined(),
  invoice_formats: Yup.array().of(Yup.string().required()).required(),
  accepts_ai_csv: Yup.boolean().required(),
  order_settings: OrderSettingsSchema.required(),
  address: AddressSchema,
  disabled: Yup.boolean().required(),

  updated_at: Yup.date().required(),
});

export type Vendor = Yup.InferType<typeof VendorSchema>;

// A vendor with no native invoice parser that instead goes through the AI-CSV
// receiving flow. accepts_ai_csv with a non-empty invoice_formats is
// intentionally not generic — native parsers win.
export const isGenericAiVendor = (vendor: Vendor): boolean =>
  vendor.accepts_ai_csv && vendor.invoice_formats.length === 0;

// normalized_name -> the label the Vendors page shows for that integration.
// Anywhere a group of sibling vendors is named for its integration, look the
// name up here: normalized_name is an internal code ('ARMA_OK') that stores
// never see anywhere else in the app.
export const integrationLabels = (integrations: VendorIntegration[]): Map<string, string> =>
  new Map(integrations.map((i) => [i.normalized_name, i.label]));
